import React, { useEffect, useState } from "react";
import Breadcrumb from "../components/Breadcrumb";
import { Helmet } from "react-helmet";
import Layout from "../components/Layout";
import Loadable from "react-loadable";
import RecsForm from "../components/RecsForm";
import Spinner from "../components/Spinner";
import classNames from "classnames";
import { initialize } from "../store/pagedata";
import styles from "../styles/recs.module.scss";
import useDarkMode from "use-dark-mode";
import { useDispatch } from "react-redux";

const Loading = () => (
  <div className={styles.spinner}>
    <Spinner className="fa-3x" />
  </div>
);

const RecsResults = Loadable({
  loader: () => import("../components/RecsResults"),
  loading: Loading,
});

const Recs = () => {
  const darkMode = useDarkMode(false);
  const dispatch = useDispatch();
  const [commander, setCommander] = useState();
  const [commander2, setCommander2] = useState();
  const [commanderName, setCommanderName] = useState("");
  const [commanderName2, setCommanderName2] = useState("");
  const [data, setData] = useState(null);
  const [decklist, setDecklist] = useState("");
  const [errors, setErrors] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    dispatch(initialize());
  }, []);

  const onBack = () => {
    setData(null);
  };

  const onSubmit = async (e) => {
    e.preventDefault();

    if (commanderName.length === 0) {
      return setErrors(["Select a commander"]);
    }

    const cards = decklist.split("\n").filter((row) => row.length > 0);
    const commanders = commanderName2 ? [commanderName, commanderName2] : [commanderName];
    const name = commanders.map((c) => c.name).join(" // ");

    setIsLoading(true);

    try {
      const res = await fetch("/api/recs/", {
        body: JSON.stringify({ cards, commanders, name }),
        headers: { "Content-Type": "application/json" },
        method: "post",
      });
      const json = await res.json();
      if (json.errors) {
        setErrors(json.errors);
      } else {
        setData(json);
        setErrors([]);
      }
      setIsLoading(false);
    } catch (error) {
      setErrors([error]);
    }
  };

  return (
    <Layout>
      <Helmet>
        <meta
          name="description"
          content="Recs - personalized deck recommendations based on hundreds of thousands of Commander decks"
        />
        <meta
          name="keywords"
          content="EDHREC,EDH,recommendations,Commander,MTG,Magic,staples,strategy,content"
        />
        <title>Recs | EDHREC</title>
      </Helmet>
      <div className={classNames({ [styles.dark]: darkMode.value })}>
        <Breadcrumb breadcrumb={[{ "/recs": "Recs" }]} />
        <h4 className="page-heading">Recs</h4>
        <div className={styles.container}>
          <div className={styles.innerContainer}>
            {data === null ? (
              <RecsForm
                commander={commander}
                commander2={commander2}
                commanderName={commanderName}
                commanderName2={commanderName2}
                decklist={decklist}
                errors={errors}
                isLoading={isLoading}
                onSubmit={onSubmit}
                setCommander={setCommander}
                setCommander2={setCommander2}
                setCommanderName={setCommanderName}
                setCommanderName2={setCommanderName2}
                setDecklist={setDecklist}
              />
            ) : (
              <RecsResults onBack={onBack} {...data} />
            )}
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Recs;
